// Geocoding utilities for address search
// Kept in separate module to prevent tree-shaking in production build

export const TIPO_CALLE = new Set([
  'street', 'road', 'avenue', 'avenue_road', 'boulevard', 'drive',
  'lane', 'way', 'path', 'footway', 'pedestrian', 'steps',
  'service', 'track', 'residential', 'living_street', 'terrace',
  'place', 'square', 'alley', 'passage', 'mews', 'crescent',
  'close', 'court', 'gate', 'grove', 'hill', 'mount', 'parade',
  'promenade', 'rise', 'row', 'vale', 'view', 'walk',
]);

export const TIPO_LABEL = {
  'street': 'Calle',
  'road': 'Calle',
  'avenue': 'Av.',
  'avenue_road': 'Av.',
  'boulevard': 'Blvd.',
  'drive': 'Av.',
  'lane': 'Pasaje',
  'way': 'Pasaje',
  'path': 'Sendero',
  'footway': 'Peatonal',
  'pedestrian': 'Peatonal',
  'steps': 'Escaleras',
  'service': 'Servicio',
  'track': 'Pista',
  'residential': 'Residencial',
  'living_street': 'Zona 30',
  'terrace': 'Terraza',
  'place': 'Plaza',
  'square': 'Plaza',
  'alley': 'Callejón',
  'passage': 'Pasaje',
  'mews': 'Pasaje',
  'crescent': 'Media luna',
  'close': 'Callejón',
  'court': 'Callejón',
  'gate': 'Entrada',
  'grove': 'Arboleda',
  'hill': 'Cerro',
  'mount': 'Cerro',
  'parade': 'Paseo',
  'promenade': 'Paseo',
  'rise': 'Subida',
  'row': 'Fila',
  'vale': 'Valle',
  'view': 'Vista',
  'walk': 'Paseo',
};

export const getTipoLabel = (type, address) => {
  if (TIPO_CALLE.has(type)) {
    return TIPO_LABEL[type] || type;
  }
  if (address?.road) return 'Calle';
  if (address?.pedestrian) return 'Peatonal';
  if (address?.footway) return 'Peatonal';
  if (address?.path) return 'Sendero';
  if (address?.square || address?.place) return 'Plaza';
  return type;
};

export const filtrarYOrdenarCalles = (resultados) => {
  return resultados
    .map(r => ({
      ...r,
      _tipo: r.type || (r.address?.road ? 'street' : r.type),
      _label: getTipoLabel(r.type || '', r.address)
    }))
    .sort((a, b) => {
      const aEsCalle = TIPO_CALLE.has(a._tipo);
      const bEsCalle = TIPO_CALLE.has(b._tipo);
      if (aEsCalle && !bEsCalle) return -1;
      if (!aEsCalle && bEsCalle) return 1;
      return 0;
    })
    .slice(0, 10);
};

export const buscarDirecciones = async (query) => {
  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=15&addressdetails=1&accept-language=es`;
  const res = await fetch(url);
  const data = await res.json();
  return filtrarYOrdenarCalles(data);
};

export const geocodificarInverso = async (lat, lng) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1&accept-language=es`;
  const res = await fetch(url);
  const data = await res.json();
  return data.display_name || `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
};

export const CENTRO_DEFECTO = { lat: -12.117939985496957, lng: -77.02892645376073 };

export const _geoModuleLoaded = true;